import React from 'react';

export const AdminPanelUploadsTab = ({ uploadFiles, backendUrl }) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm p-6" data-testid="admin-panel-uploads-tab">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Arquivos Upload</h2>
      {uploadFiles.length > 0 ? (
        <div className="space-y-4" data-testid="admin-panel-upload-files-list">
          {uploadFiles.map((file) => (
            <div key={`${file.contactId}-${file.stored_name}`} className="border border-gray-200 rounded-xl p-4 flex items-center justify-between gap-4" data-testid={`admin-panel-upload-item-${file.stored_name}`}>
              <div>
                <p className="font-medium text-gray-900">{file.original_name}</p>
                <p className="text-sm text-gray-500">Enviado por {file.contactName}</p>
              </div>
              <a
                href={`${backendUrl}${file.url}`}
                target="_blank"
                rel="noreferrer"
                className="px-4 py-2 rounded-lg bg-blue-50 text-blue-700 hover:bg-blue-100 transition"
                data-testid={`admin-panel-upload-link-${file.stored_name}`}
              >
                Abrir arquivo
              </a>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500" data-testid="admin-panel-uploads-empty">Nenhum arquivo enviado até agora.</p>
      )}
    </div>
  );
};
